export const toCleanBase64 = (dataUrlOrBase64) => {
  if (!dataUrlOrBase64) return ''

  let value = dataUrlOrBase64.trim()

  if (value.includes(',')) {
    value = value.split(',')[1]
  }

  value = value.replace(/\s/g, '')

  const padding = value.length % 4

  if (padding) {
    value += '='.repeat(4 - padding)
  }

  return value
}